export default "__VITE_ASSET__DFbcWfZk__"